module.exports = __webpack_public_path__ + "img/brand-1.22862e4c.jpg";